import React, { useState, useEffect } from "react";
import DropDown from "./DropDown";
import logo from "../../assets/images/Logo Main.svg";
import client from "../../utils/prismicHelpers";
import * as queries from "../../utils/prismicQueries";
import { useNavigate } from "react-router-dom";
import Emitter from "../../utils/emitter";
import { useLocation } from "react-router-dom";
const DesktopNavbar = () => {
  const [btnValue, setBtnValue] = useState(null);
  const [currentTab, setCurrentTab] = useState(1);
  const [contact, setContactStyle] = useState(null);
  const [hideSearch, setHideSearch] = useState(false);
  const [navInfo, setNavInfo] = useState([]);
  const [searchPath, setSearchPath] = useState([]);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [searchResult, setSearchResult] = useState([]);
  const toggleDropDown = (dropNo, area, route) => {
    if (
      area === "Innovation Fellow" ||
      area === "Investment Committee" ||
      area === "Venture Fund" ||
      area === "Cohorts" ||
      area === "View Programs"
    ) {
      sessionStorage.setItem("InnovationSection", area);
      Emitter.emit("MOVE_INNOVATION_SECTION", area);
    }
    sessionStorage.setItem("dropNo", dropNo);
    if (route !== null && route.slice(0, 1) !== "/") {
      navigate(route);
    }
    if (dropNo === 4) {
      navigate(area);
    }

    setCurrentTab(dropNo);
    if (btnValue === dropNo) {
      setBtnValue(null);
    } else {
      setBtnValue(dropNo);
      setContactStyle(false);
    }
  };

  useEffect(() => {
    client
      .query({
        query: queries.navInfo2,
      })
      .then((response) => {
        const navDoc = response.data.allNavbar2s.edges[0].node?.nav_link;
        const searchDoc = response.data.allSearch_bys.edges[0].node.search;
        setNavInfo(navDoc);
        setSearchPath(searchDoc);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  useEffect(() => {
    let dropNo = sessionStorage.getItem("dropNo");
    setCurrentTab(dropNo);
  }, [location]);

  const handleKeyup = (e) => {
    e.preventDefault();
    let searchText = e.target.value.toLowerCase();
    setSearchText(searchText);
    setHideSearch(false);
    if (searchText !== "") {
      searchText.toLowerCase();
      let showValue = searchPath.filter((link) =>
        link.keyword.toLowerCase().includes(searchText.toLowerCase())
      );

      setSearchResult(showValue && showValue);
    } else {
      setSearchResult([]);
    }
  };
  const handleContact = (condition, dropNo) => {
    setContactStyle(condition);
    setCurrentTab(dropNo);
    sessionStorage.setItem("dropNo", dropNo);
  };
  const handleSearch = (path) => {
    // console.log("clicked", path);
    setHideSearch(true);
    if (path !== null && path.slice(0, 1) !== "/") {
      navigate(path);
    }
  };
  return (
    <>
      <nav className="navbar navbar-expand-lg   top-nav">
        <div className="container-fluid py-2  ">
          <a className="navbar-brand" href="/">
            <img src={logo} alt="logo" />
          </a>

          <div
            className="collapse navbar-collapse d-flex justify-content-center"
            id="navbarSupportedContent"
          >
            <ul className="nav nav-tabs ">
              {navInfo?.map((navData, index) => (
                <DropDown
                  handleContact={handleContact}
                  linkInfo={navData}
                  key={index + 1}
                  contact={contact}
                  dropNo={index + 1}
                  currentTab={currentTab}
                  btnValue={btnValue}
                  toggleDropDown={toggleDropDown}
                />
              ))}
            </ul>
          </div>
          {/* <form data-bs-toggle="tab" className="pe-4">
            <div className="search-container">
              <div className="searchbar">
                <label htmlFor="search-input" className="search-icon-wrapper">
                  <div className="search-icon"></div>
                </label>
                <input type="text" className="search-input" onChange={(e) => handleKeyup(e)} id="search-input" placeholder="Search..."></input>
              </div>
            </div> */}

          {/* <ul className={`${searchResult.length === 0 ? "d-none" : "d-block"}  position-absolute bg-white px-4 mt-1 rounded-2   list-unstyled`}>
              {searchResult.map(searchLink =>
                <li>
                  <a
                    onClick={() => handleSearch(searchLink?.path)}
                    className="text-decoration-none pinter-cursor fs-6  primary-text"
                    href={searchLink?.path?.slice(0, 1) === "/" && searchLink?.path} >
                    {searchLink?.path.slice(0, 1) === "/" ? searchLink?.path.slice(2, 50) + ">" + searchText : searchLink?.path + searchText}
                  </a>
                </li>
              )}
            </ul> */}
          {/* </form> */}
        </div>
        {/* <div className={`container-fluid ${hideSearch ? "d-none" : "d-block"}`}>
          <div className="row g-2">
            {searchResult.map(searchLink => <SearchIItem searchLink={searchLink} handleSearch={handleSearch} />)}
          </div>
        </div> */}
      </nav>
    </>
  );
};

export default DesktopNavbar;
